export default "__VITE_ASSET__Dt9adNha__"